// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Leibniz from "../Data.Leibniz/index.js";
import * as Data_Loading from "../Data.Loading/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Form_Checkbox from "../Restaumatic.Form.Checkbox/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_EditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_HasDefaultValue from "../Restaumatic.Form.HasDefaultValue/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic_Form_Value from "../Restaumatic.Form.Value/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map3 = /* #__PURE__ */ Data_Functor.map(Specular_Select.functorOption);
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Value.applicativeValue);
var getContext = /* #__PURE__ */ Restaumatic_Form_Internal.getContext(Restaumatic_Form_Internal.hasContextRefContext);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var read = /* #__PURE__ */ Specular_Ref.read(Effect_Class.monadEffectEffect);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var append = /* #__PURE__ */ Data_Semigroup.append(Restaumatic_Form_Errors.semigroupFormErrors);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var modify1 = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Vault.semigroupVault);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Loading.monoidLoadingStatus);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Result.applicativeResult);
var map4 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Result.functorResult);
var from = /* #__PURE__ */ Type_Equality.from(Type_Equality.refl);
var $$switch = /* #__PURE__ */ Specular_Extra_Switch["switch"](Specular_Extra_Switch.switchEvent);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var relax = /* #__PURE__ */ Restaumatic_Form_DynamicResult.relax();
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var when = /* #__PURE__ */ Control_Applicative.when(Effect.applicativeEffect);
var map5 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(/* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString)));
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(valueIsSymbol);
var touchedIsSymbol = {
    reflectSymbol: function () {
        return "touched";
    }
};
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode);
var readValueIsSymbol = {
    reflectSymbol: function () {
        return "readValue";
    }
};
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode);
var readValidationErrorsIsSymbol = {
    reflectSymbol: function () {
        return "readValidationErrors";
    }
};
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode));
var displayedErrorsIsSymbol = {
    reflectSymbol: function () {
        return "displayedErrors";
    }
};
var defaultValueIsSymbol = {
    reflectSymbol: function () {
        return "defaultValue";
    }
};
var sequenceRecord = /* #__PURE__ */ Record_Extra.sequenceRecord()(/* #__PURE__ */ Record_Extra.sequenceRecordCons(defaultValueIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(displayedErrorsIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(readValidationErrorsIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(readValueIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(touchedIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordSingle(valueIsSymbol)()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()());
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
var optionForEq = /* #__PURE__ */ Restaumatic_Form_Internal.optionForEq();
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var $$new = /* #__PURE__ */ Specular_Ref["new"](Specular_FRP_Host.monadEffectHost);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_Vault.monoidVault);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_FRP_Host.monadEffectHost);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var pure4 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString));
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(Restaumatic_Form_Errors.monoidFormErrors);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray)(Restaumatic_Form_Errors.monoidFormErrors);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Specular_FRP_Base.applicativeDynamic);
var discard2 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var annotate = /* #__PURE__ */ Specular_FRP_Base.annotate(Specular_FRP_Host.monadEffectHost);
var pure5 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var FormField = function (x) {
    return x;
};
var queryFormField$prime = function (dictTypeEquals) {
    var from1 = Type_Equality.from(dictTypeEquals);
    return {
        queryImpl: function (v) {
            return function (v1) {
                if (v instanceof Restaumatic_Form_Query.Lax) {
                    return map(from1)(v1.cachedQueryLax);
                };
                if (v instanceof Restaumatic_Form_Query.Strict) {
                    return map(from1)(v1.cachedQuery);
                };
                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 77, column 1 - line 79, column 75): " + [ v.constructor.name, v1.constructor.name ]);
            };
        }
    };
};
var queryImpl = /* #__PURE__ */ Restaumatic_Form_Query.queryImpl(/* #__PURE__ */ queryFormField$prime(Type_Equality.refl));
var metadataValueNoMetadata = function () {
    return {
        getMetadataValue: function (v) {
            return {
                label: Data_Maybe.Nothing.value,
                options: Data_Maybe.Nothing.value
            };
        }
    };
};
var metadataValueNestedMetada = function () {
    return function (dictTypeEquals) {
        var from1 = Type_Equality.from(dictTypeEquals);
        return {
            getMetadataValue: function (v) {
                return {
                    label: v.label,
                    options: map1(map2(map3(from1)))(v.options)
                };
            }
        };
    };
};
var metadataValueMetadata = function () {
    return function (dictTypeEquals) {
        var from1 = Type_Equality.from(dictTypeEquals);
        return {
            getMetadataValue: function (v) {
                return {
                    label: v.label,
                    options: map1(map2(map3(from1)))(v.options)
                };
            }
        };
    };
};
var mergeFormField$prime = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        merge: function (x) {
            return function (v) {
                return write(v.value)(new Restaumatic_Form_Internal.Valid({
                    value: to(x),
                    editValue: Data_Maybe.Nothing.value
                }));
            };
        }
    };
};
var initializeSomeInitializer = {
    makeImpl: Restaumatic_Form_Internal.makeWithSomeInitializer
};
var initializeSomeInitialValu = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(Restaumatic_Form_Internal.makeWithInitialValueIniti1(dictInitialize))
    };
};
var initializeNoInitializerFo = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithDefaultInitializer(dictInitialize)({})
    };
};
var initializeNoInitialValueI = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(Restaumatic_Form_Internal.makeWithInitialValueIniti(dictInitialize))
    };
};
var initializeMetadataInitial = function (dictMakeWithMetadataInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithMetadataInitializer(dictMakeWithMetadataInitializer)
    };
};
var initializeEffectInitializ = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithEffectInitializer(dictInitialize)
    };
};
var initializeContextInitiali = function (dictAddContext) {
    return function (dictInitialize) {
        return {
            makeImpl: Restaumatic_Form_Internal.makeWithContextInitializer(dictInitialize)(dictAddContext)
        };
    };
};
var initialValueTotalNoInitia = function (dictHasDefaultValue) {
    var defaultValue = Restaumatic_Form_HasDefaultValue.defaultValue(dictHasDefaultValue);
    return {
        getInitialValue: function (v) {
            return function (v1) {
                return pure(defaultValue);
            };
        }
    };
};
var initialValueSomeInitialVa = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        getInitialValue: function (v) {
            return function (v1) {
                return pure(to(v1.value0));
            };
        }
    };
};
var initialValuePartialNoInit = {
    getInitialValue: function (v) {
        return function (v1) {
            return Restaumatic_Form_Value.noValue;
        };
    }
};
var hasContextFormField$prime = {
    getContext: function (v) {
        return getContext(v.context);
    }
};
var dynamicFromContext = /* #__PURE__ */ Restaumatic_Form_Internal.dynamicFromContext(hasContextFormField$prime);
var formFieldLikeFormField$prime = {
    withFormFieldD: function (f) {
        return function (field) {
            return f(field);
        };
    }
};
var addErrorsFormField$prime = {
    addErrors: function (errors) {
        return function (v) {
            var mErrors = Foreign_Object.lookup(Restaumatic_Form_Internal.fieldPathToString(v.name))(errors);
            if (mErrors instanceof Data_Maybe.Just) {
                return function __do() {
                    var v1 = read(v.value)();
                    (function () {
                        if (v1 instanceof Restaumatic_Form_Internal.Undefined) {
                            return write(v.value)(new Restaumatic_Form_Internal.Invalid({
                                error: Restaumatic_Form_Errors.userVisibleErrors(mErrors.value0),
                                lastValid: v1.value0.lastValid,
                                editValue: Data_Maybe.Nothing.value
                            }))();
                        };
                        if (v1 instanceof Restaumatic_Form_Internal.Valid) {
                            return write(v.value)(new Restaumatic_Form_Internal.Invalid({
                                error: Restaumatic_Form_Errors.userVisibleErrors(mErrors.value0),
                                lastValid: new Restaumatic_Form_Value.SomeValue(v1.value0.value),
                                editValue: v1.value0.editValue
                            }))();
                        };
                        if (v1 instanceof Restaumatic_Form_Internal.Invalid) {
                            return write(v.value)(new Restaumatic_Form_Internal.Invalid({
                                error: append(v1.value0.error)(Restaumatic_Form_Errors.userVisibleErrors(mErrors.value0)),
                                lastValid: v1.value0.lastValid,
                                editValue: v1.value0.editValue
                            }))();
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 203, column 9 - line 210, column 111): " + [ v1.constructor.name ]);
                    })();
                    return write(v.touched)(true)();
                };
            };
            if (mErrors instanceof Data_Maybe.Nothing) {
                return pure1(Data_Unit.unit);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 200, column 5 - line 212, column 27): " + [ mErrors.constructor.name ]);
        };
    }
};
var addContextFormField$prime = {
    addContext: function (ctx) {
        return function (v) {
            return modify1(v.context)(function (v1) {
                return append1(ctx)(v1);
            });
        };
    }
};
var withFormFieldD = function (dict) {
    return dict.withFormFieldD;
};
var formFieldLikeDelayed = function (dictFormFieldLike) {
    var withFormFieldD1 = withFormFieldD(dictFormFieldLike);
    return {
        withFormFieldD: function (f) {
            return function (v) {
                return bind1(v)(withFormFieldD1(f));
            };
        }
    };
};
var valueStateToResult = function (name) {
    return function (label) {
        return function (valueState) {
            return function (errors) {
                var value$prime = (function () {
                    if (valueState instanceof Restaumatic_Form_Internal.Undefined) {
                        return new Restaumatic_Form_Result.Result(mempty, Restaumatic_Form_Internal.requiredError(Data_Unit.unit), valueState.value0.lastValid);
                    };
                    if (valueState instanceof Restaumatic_Form_Internal.Valid) {
                        return pure2(valueState.value0.value);
                    };
                    if (valueState instanceof Restaumatic_Form_Internal.Invalid) {
                        return new Restaumatic_Form_Result.Result(mempty, valueState.value0.error, valueState.value0.lastValid);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 85, column 7 - line 91, column 40): " + [ valueState.constructor.name ]);
                })();
                return Restaumatic_Form_Result.mapErrors((function () {
                    var $442 = Restaumatic_Form_Internal.tagErrors(name)(label);
                    return function ($443) {
                        return (function (v) {
                            return append(v)(errors);
                        })($442($443));
                    };
                })())(map4(from)(value$prime));
            };
        };
    };
};
var userEdit = function (dictFormFieldLike) {
    var withFormFieldD1 = withFormFieldD(dictFormFieldLike);
    return function (df) {
        return $$switch(Data_Function.flip(withFormFieldD1)(df)(function (v) {
            return pure3(v.userEdit.event);
        }));
    };
};
var toFormFieldE = function (dictFormFieldLike) {
    var $444 = withFormFieldD(dictFormFieldLike)(pure3);
    return function ($445) {
        return readDynamic($444($445));
    };
};
var touch = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function __do() {
            var v = toFormFieldE1(df)();
            return write(v.touched)(true)();
        };
    };
};
var touch1 = /* #__PURE__ */ touch(formFieldLikeFormField$prime);
var writeValue = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (v) {
            return function __do() {
                var v1 = toFormFieldE1(df)();
                return v1.onWriteValue(v1)(v)();
            };
        };
    };
};
var writeValue1 = /* #__PURE__ */ writeValue(formFieldLikeFormField$prime);
var writeValidValue = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictFormFieldLike) {
        var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
        return function (dfield) {
            return function (value) {
                return liftEffect1(function __do() {
                    var field = toFormFieldE1(dfield)();
                    return writeValue1(field)(new Restaumatic_Form_Internal.Valid({
                        value: value,
                        editValue: Data_Maybe.Nothing.value
                    }))();
                });
            };
        };
    };
};
var writeValidValue1 = /* #__PURE__ */ writeValidValue(Effect_Class.monadEffectEffect)(formFieldLikeFormField$prime);
var readValueState = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        return v.readValueState;
    });
};
var readValueState1 = /* #__PURE__ */ readValueState(formFieldLikeFormField$prime);
var isTextFieldFormField$prime = function (dictEditAsString) {
    var parse = Restaumatic_Form_EditAsString.parse(dictEditAsString);
    var toString = Restaumatic_Form_EditAsString.toString(dictEditAsString);
    return {
        textInput: function (field) {
            var parse$prime = function (str) {
                var v = parse(str);
                if (v instanceof Data_Either.Left) {
                    return new Restaumatic_Form_Internal.Invalid({
                        error: Restaumatic_Form_Errors.userVisibleError(v.value0),
                        lastValid: Restaumatic_Form_Value.noValue,
                        editValue: new Data_Maybe.Just(str)
                    });
                };
                if (v instanceof Data_Either.Right) {
                    return new Restaumatic_Form_Internal.Valid({
                        value: v.value0,
                        editValue: new Data_Maybe.Just(str)
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 399, column 7 - line 403, column 47): " + [ v.constructor.name ]);
            };
            return {
                displayedValue: mapFlipped(readValueState1(field))(function (v) {
                    if (v instanceof Restaumatic_Form_Internal.Undefined) {
                        return "";
                    };
                    if (v instanceof Restaumatic_Form_Internal.Invalid) {
                        return Data_Maybe.fromMaybe("")(v.value0.editValue);
                    };
                    if (v instanceof Restaumatic_Form_Internal.Valid && v.value0.editValue instanceof Data_Maybe.Just) {
                        return v.value0.editValue.value0;
                    };
                    if (v instanceof Restaumatic_Form_Internal.Valid && v.value0.editValue instanceof Data_Maybe.Nothing) {
                        return toString(v.value0.value);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 381, column 9 - line 389, column 40): " + [ v.constructor.name ]);
                }),
                onChange: function (str) {
                    return writeValue1(field)(parse$prime(str));
                },
                onTouch: touch1(field),
                placeholder: pure3("")
            };
        }
    };
};
var readValueF = function (dictFormFieldLike) {
    var $446 = withFormFieldD(dictFormFieldLike)(function (v) {
        return Restaumatic_Form_DynamicResult.unwrap(v.cachedQueryLax);
    });
    return function ($447) {
        return relax(Restaumatic_Form_DynamicResult.wrap($446($447)));
    };
};
var readValueF1 = /* #__PURE__ */ readValueF(formFieldLikeFormField$prime);
var isCheckboxFieldFormField$prime = function (dictAsCheckboxState) {
    var fromBoolean = Restaumatic_Form_Checkbox.fromBoolean(dictAsCheckboxState);
    var toTristate = Restaumatic_Form_Checkbox.toTristate(dictAsCheckboxState);
    return {
        checkboxInput: function (v) {
            return liftEffect(function __do() {
                var initial = readDynamic(Restaumatic_Form_Final.unFinal(readValueF1(v)))();
                when(Data_Maybe.isNothing(initial))(write(v.value)(new Restaumatic_Form_Internal.Valid({
                    value: fromBoolean(false),
                    editValue: Data_Maybe.Nothing.value
                })))();
                return {
                    displayedValue: map5(Data_Maybe.maybe(Restaumatic_Form_Checkbox.Unchecked.value)(toTristate))(Restaumatic_Form_Final.unFinal(readValueF1(v))),
                    onChange: (function () {
                        var $448 = writeValidValue1(v);
                        return function ($449) {
                            return $448(fromBoolean($449));
                        };
                    })()
                };
            });
        }
    };
};
var isRefLikeFormField$prime = {
    readRefLike: function (f) {
        return Restaumatic_Form_Final.unFinal(readValueF1(f));
    },
    writeRefLike: writeValue1,
    touchRefLike: touch1
};
var writeRefLike = /* #__PURE__ */ Restaumatic_Form_Internal.writeRefLike(isRefLikeFormField$prime);
var mergeInputRequiredFormFie = {
    mergeInputRequired: function (field) {
        return writeRefLike(field)(new Restaumatic_Form_Internal.Invalid({
            error: Restaumatic_Form_Internal.requiredError(Data_Unit.unit),
            lastValid: Restaumatic_Form_Value.noValue,
            editValue: Data_Maybe.Nothing.value
        }));
    }
};
var readValidationErrors = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        var getErrors = (function () {
            var $450 = map2(function (v1) {
                return v1.message;
            });
            var $451 = Data_Array.filter(function ($455) {
                return !(function (v1) {
                    return v1.internal;
                })($455);
            });
            var $452 = Data_Maybe.fromMaybe([  ]);
            var $453 = lookup(new Data_Maybe.Just(v.name));
            return function ($454) {
                return $450($451($452($453(unwrap($454)))));
            };
        })();
        return map5(getErrors)(Restaumatic_Form_DynamicResult.errors(queryImpl(Restaumatic_Form_Query.Strict.value)(v)));
    });
};
var readValidationErrors1 = /* #__PURE__ */ readValidationErrors(formFieldLikeFormField$prime);
var hasErrorsFormField$prime = {
    displayedErrors: function (v) {
        return apply(apply(map5(function (v1) {
            return function (v2) {
                return function (v3) {
                    var $388 = v1 || v2;
                    if ($388) {
                        return v3;
                    };
                    return [  ];
                };
            };
        })(Specular_Ref.value(v.touched)))(map5(Data_Maybe.fromMaybe(false))(dynamicFromContext(Restaumatic_Form_Internal.forceDisplayErrorsKey)(v))))(readValidationErrors1(v));
    }
};
var displayedErrors = /* #__PURE__ */ Restaumatic_Form_Internal.displayedErrors(hasErrorsFormField$prime);
var dumpStateFormField$prime = function (dictEncode) {
    var encodeWithOptionsOther3 = Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(dictEncode));
    var encode1 = Foreign_Generic_Class.encode(dictEncode);
    return function (dictEncode1) {
        var encode2 = Foreign_Generic_Class.encode(recordEncode(encodeRecordCons(encodeRecordCons(encodeRecordCons(encodeRecordCons(encodeRecordCons(encodeRecordCons1(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode1)))(touchedIsSymbol)(encodeWithOptionsOther))(readValueIsSymbol)(encodeWithOptionsOther1))(readValidationErrorsIsSymbol)(encodeWithOptionsOther2))(displayedErrorsIsSymbol)(encodeWithOptionsOther2))(defaultValueIsSymbol)(encodeWithOptionsOther3)));
        return {
            dumpState: function (v) {
                return map5(encode2)(sequenceRecord({
                    value: Specular_Ref.value(v.value),
                    defaultValue: Restaumatic_Form_Final.unFinal(v.defaultValue),
                    touched: Specular_Ref.value(v.touched),
                    readValue: map5(Data_Maybe.maybe(encode("(NO READ VALUE)"))(encode1))(Restaumatic_Form_Final.unFinal(readValueF1(v))),
                    readValidationErrors: readValidationErrors1(v),
                    displayedErrors: displayedErrors(v)
                }));
            }
        };
    };
};
var readOptions = function () {
    return function (dictFormFieldLike) {
        return withFormFieldD(dictFormFieldLike)(function (v) {
            return map5(Data_Maybe.maybe([  ])(Data_Leibniz.runLeibniz(optionForEq)))(Restaumatic_Form_Final.unFinal(v.options));
        });
    };
};
var readOptions1 = /* #__PURE__ */ readOptions()(formFieldLikeFormField$prime);
var isMultiSelectFieldFormFie = function (dictContainer) {
    var fromArray = Restaumatic_Form_Internal.fromArray(dictContainer);
    var maybeContainerToArray = Restaumatic_Form_Internal.maybeContainerToArray(dictContainer);
    return function () {
        return {
            mSelectWriteValue: function (field) {
                return function (value) {
                    return writeValidValue1(field)(fromArray(value));
                };
            },
            mSelectReadValue: function (field) {
                return map5(maybeContainerToArray)(Restaumatic_Form_Final.unFinal(readValueF1(field)));
            },
            mSelectGetOptions: readOptions1,
            mSelectTouch: touch1
        };
    };
};
var isSelectFieldFormField$prime = function () {
    return {
        selectWriteValue: writeValidValue1,
        selectReadValue: function ($456) {
            return Restaumatic_Form_Final.unFinal(readValueF1($456));
        },
        selectGetOptions: readOptions1,
        selectTouch: touch1
    };
};
var readLabel = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        return Restaumatic_Form_Final.unFinal(v.label);
    });
};
var hasLabelFormField$prime = {
    getLabel: /* #__PURE__ */ readLabel(formFieldLikeFormField$prime)
};
var modifyValidValue = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (update) {
            return function __do() {
                var v = toFormFieldE1(df)();
                var old = readDynamic(Restaumatic_Form_Final.unFinal(readValueF1(v)))();
                writeValidValue1(v)(update(old))();
                touch1(v)();
                return v.userEdit.fire(Data_Unit.unit)();
            };
        };
    };
};
var modify = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (update) {
            return function __do() {
                var v = toFormFieldE1(df)();
                var old = readDynamic(Restaumatic_Form_Final.unFinal(readValueF1(v)))();
                if (old instanceof Data_Maybe.Nothing) {
                    return Data_Unit.unit;
                };
                if (old instanceof Data_Maybe.Just) {
                    writeValidValue1(v)(update(old.value0))();
                    touch1(v)();
                    return v.userEdit.fire(Data_Unit.unit)();
                };
                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 152, column 3 - line 158, column 27): " + [ old.constructor.name ]);
            };
        };
    };
};
var isTouched = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        return Specular_Ref.value(v.touched);
    });
};
var getMetadataValue = function (dict) {
    return dict.getMetadataValue;
};
var metadataValueSomeMetadata = function () {
    return function (dictMetadataValue) {
        var getMetadataValue1 = getMetadataValue(dictMetadataValue);
        return {
            getMetadataValue: function (v) {
                return getMetadataValue1(v.value0);
            }
        };
    };
};
var getLastValid = function (v) {
    if (v instanceof Restaumatic_Form_Internal.Undefined) {
        return v.value0.lastValid;
    };
    if (v instanceof Restaumatic_Form_Internal.Invalid) {
        return v.value0.lastValid;
    };
    if (v instanceof Restaumatic_Form_Internal.Valid) {
        return pure(v.value0.value);
    };
    throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 142, column 3 - line 145, column 34): " + [ v.constructor.name ]);
};
var getInitialValue = function (dict) {
    return dict.getInitialValue;
};
var fieldNameString = function (v) {
    return Restaumatic_Form_Internal.fieldPathToString(v.name);
};
var hasFieldIdFormField$prime = {
    getFieldId: fieldNameString
};
var copyStateFormField = {
    copyState: function (v) {
        return function (v1) {
            return bind(read(v.value))(write(v1.value));
        };
    }
};
var augmentWithLastValid = function (v) {
    return function (v1) {
        if (v instanceof Restaumatic_Form_Internal.Undefined) {
            return new Restaumatic_Form_Internal.Undefined({
                lastValid: Restaumatic_Form_Value.orElse(v.value0.lastValid)(getLastValid(v1))
            });
        };
        if (v instanceof Restaumatic_Form_Internal.Invalid) {
            return new Restaumatic_Form_Internal.Invalid({
                error: v.value0.error,
                editValue: v.value0.editValue,
                lastValid: Restaumatic_Form_Value.orElse(v.value0.lastValid)(getLastValid(v1))
            });
        };
        if (v instanceof Restaumatic_Form_Internal.Valid) {
            return new Restaumatic_Form_Internal.Valid(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 135, column 1 - line 135, column 91): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var defaultWriteValue = function (v) {
    return function (v1) {
        return function __do() {
            modify1(v.value)(augmentWithLastValid(v1))();
            write(v.touched)(true)();
            return v.userEdit.fire(Data_Unit.unit)();
        };
    };
};
var initializeRecordFormField = function (dictFromDefaults) {
    var fromDefaults = Data_NamedParams.fromDefaults(dictFromDefaults);
    return function (dictIsTotality) {
        var isTotal = Restaumatic_Form_Totality.isTotal(dictIsTotality);
        return function () {
            return function (dictInitialValue) {
                var getInitialValue1 = getInitialValue(dictInitialValue);
                return function (dictMetadataValue) {
                    var getMetadataValue1 = getMetadataValue(dictMetadataValue);
                    return {
                        makeImpl: function (v) {
                            return function (opts) {
                                return function (mMeta) {
                                    return function (iv) {
                                        return function (initializer) {
                                            return bind2($$new((function () {
                                                var v1 = getInitialValue1(Type_Proxy["Proxy"].value)(iv);
                                                if (v1 instanceof Restaumatic_Form_Value.SomeValue) {
                                                    return new Restaumatic_Form_Internal.Valid({
                                                        value: v1.value0,
                                                        editValue: Data_Maybe.Nothing.value
                                                    });
                                                };
                                                if (v1 instanceof Restaumatic_Form_Value.NoValue) {
                                                    return new Restaumatic_Form_Internal.Undefined({
                                                        lastValid: v1
                                                    });
                                                };
                                                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 255, column 7 - line 257, column 52): " + [ v1.constructor.name ]);
                                            })()))(function (value) {
                                                return bind2($$new(false))(function (touched) {
                                                    return bind2($$new(mempty1))(function (context) {
                                                        return bind2(newEvent)(function (userEdit_) {
                                                            var v1 = getMetadataValue1(mMeta);
                                                            var params = fromDefaults({
                                                                defaultValue: Restaumatic_Form_Final.makeFinalV(pure3(Data_Validation_Semigroup.invalid(Restaumatic_Form_Internal.requiredError(Data_Unit.unit)))),
                                                                normalize: pure3(identity),
                                                                onWriteValue: defaultWriteValue,
                                                                options: pure4(Data_Maybe.fromMaybe([  ])(v1.options)),
                                                                label: pure4(Data_Maybe.fromMaybe("")(v1.label)),
                                                                validations: [  ]
                                                            })(initializer);
                                                            var options_ = Data_Leibniz.runLeibniz(Data_Leibniz.liftLeibniz(Data_Leibniz.symm(optionForEq)))(params.options);
                                                            var readValueState_ = Specular_FRP_Base.annotated("FormField.readValueState " + show(opts.name))(apply(apply(map5(function (v2) {
                                                                return function (v3) {
                                                                    return function (v4) {
                                                                        if (v4 instanceof Restaumatic_Form_Internal.Undefined) {
                                                                            return Data_Validation_Semigroup.validation(function (e) {
                                                                                return new Restaumatic_Form_Internal.Invalid({
                                                                                    error: append(Restaumatic_Form_Internal.requiredError(Data_Unit.unit))(e),
                                                                                    lastValid: v4.value0.lastValid,
                                                                                    editValue: Data_Maybe.Nothing.value
                                                                                });
                                                                            })(function (x) {
                                                                                return new Restaumatic_Form_Internal.Valid({
                                                                                    value: x,
                                                                                    editValue: Data_Maybe.Nothing.value
                                                                                });
                                                                            })(v2);
                                                                        };
                                                                        if (v4 instanceof Restaumatic_Form_Internal.Valid) {
                                                                            return new Restaumatic_Form_Internal.Valid({
                                                                                value: v3(v4.value0.value),
                                                                                editValue: v4.value0.editValue
                                                                            });
                                                                        };
                                                                        return v4;
                                                                    };
                                                                };
                                                            })(Restaumatic_Form_Final.unFinalV(params.defaultValue)))(params.normalize))(Specular_Ref.value(value)));
                                                            var extractErrors = function (label1) {
                                                                var toErrors = function (v2) {
                                                                    if (v2.length === 0) {
                                                                        return mempty2;
                                                                    };
                                                                    return wrap(Data_Map_Internal.singleton(new Data_Maybe.Just(opts.name))(mapFlipped1(v2)(function (message) {
                                                                        return {
                                                                            fieldName: new Data_Maybe.Just(opts.name),
                                                                            fieldLabel: label1,
                                                                            message: message,
                                                                            internal: false
                                                                        };
                                                                    })));
                                                                };
                                                                var extractErrors$prime = Data_Validation_Semigroup.validation(identity)(toErrors);
                                                                return foldMap(extractErrors$prime);
                                                            };
                                                            var cachedQueryLax = Restaumatic_Form_DynamicResult.wrap(Specular_FRP_Base.annotated("queryLax")(apply(map5(function (v2) {
                                                                return function (v3) {
                                                                    return valueStateToResult(opts.name)(v3)(v2)(mempty2);
                                                                };
                                                            })(readValueState_))(Restaumatic_Form_Final.unFinal(params.label))));
                                                            var valueF = Restaumatic_Form_DynamicResult.toLax(cachedQueryLax);
                                                            var cachedQuery = Restaumatic_Form_DynamicResult.wrap(Specular_FRP_Base.annotated("query")(apply(apply(map5(function (v2) {
                                                                return function (v3) {
                                                                    return function (v4) {
                                                                        return valueStateToResult(opts.name)(v4)(v3)(extractErrors(v4)(v2));
                                                                    };
                                                                };
                                                            })(sequence(map2(function (v2) {
                                                                return Restaumatic_Form_Final.unFinalV(v2(valueF));
                                                            })(params.validations))))(readValueState_))(Restaumatic_Form_Final.unFinal(params.label))));
                                                            return discard2(annotate(Specular_Ref.value(value))("FormField.value"))(function () {
                                                                return discard2(annotate(Specular_Ref.value(touched))("FormField.touched"))(function () {
                                                                    return pure5({
                                                                        name: opts.name,
                                                                        label: params.label,
                                                                        value: value,
                                                                        defaultValue: params.defaultValue,
                                                                        touched: touched,
                                                                        options: options_,
                                                                        context: context,
                                                                        normalize: params.normalize,
                                                                        userEdit: userEdit_,
                                                                        readValueState: readValueState_,
                                                                        onWriteValue: params.onWriteValue,
                                                                        isTotal: isTotal(Type_Proxy["Proxy"].value),
                                                                        cachedQuery: cachedQuery,
                                                                        cachedQueryLax: cachedQueryLax
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        };
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var writeValueNoTouch = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (v) {
            return function __do() {
                var v1 = toFormFieldE1(df)();
                modify1(v1.value)(augmentWithLastValid(v))();
                return v1.userEdit.fire(Data_Unit.unit)();
            };
        };
    };
};
export {
    getInitialValue,
    getMetadataValue,
    withFormFieldD,
    FormField,
    toFormFieldE,
    valueStateToResult,
    readValueF,
    readValueState,
    fieldNameString,
    writeValidValue,
    writeValue,
    defaultWriteValue,
    writeValueNoTouch,
    augmentWithLastValid,
    getLastValid,
    modify,
    modifyValidValue,
    touch,
    readOptions,
    readLabel,
    readValidationErrors,
    isTouched,
    userEdit,
    formFieldLikeFormField$prime,
    formFieldLikeDelayed,
    queryFormField$prime,
    hasErrorsFormField$prime,
    addErrorsFormField$prime,
    dumpStateFormField$prime,
    initializeRecordFormField,
    mergeFormField$prime,
    mergeInputRequiredFormFie,
    addContextFormField$prime,
    initialValuePartialNoInit,
    initialValueTotalNoInitia,
    initialValueSomeInitialVa,
    metadataValueNoMetadata,
    metadataValueSomeMetadata,
    metadataValueMetadata,
    metadataValueNestedMetada,
    isTextFieldFormField$prime,
    hasLabelFormField$prime,
    isSelectFieldFormField$prime,
    isMultiSelectFieldFormFie,
    isRefLikeFormField$prime,
    isCheckboxFieldFormField$prime,
    copyStateFormField,
    hasFieldIdFormField$prime,
    hasContextFormField$prime,
    initializeNoInitialValueI,
    initializeSomeInitialValu,
    initializeMetadataInitial,
    initializeContextInitiali,
    initializeEffectInitializ,
    initializeNoInitializerFo,
    initializeSomeInitializer
};
